import Player from '@/services/player/Player';

export default class Players {
  constructor(numPlayers = 1) {
    this._players = [];

    for (let i = 0; i < numPlayers; i++) {
      this.add();
    }
  };

  add() {
    this._players.push(new Player());
  };
  remove(index) {
    this._players.splice(index, 1);
  };
  find(index) {
    return this._players[index];
  };
  forEach(cb, thisValue) {
    this._players.forEach(function (player, index) {
      cb.call(thisValue, player, index);
    });
  };
  get last() {
    return this._players[this._players.length - 1];
  };
  get numPlayers() {
    return this._players.length;
  };

  // hands
  deselectAllSpecificHandsThatUseCardAndSetAsImpossible(card, shortDeck) {
    this._players.forEach(function (player) {
      player.deselectAllSpecificHandsThatUseCardAndSetAsImpossible(card, shortDeck);
    });
  };
  selectAllSpecificHandsThatUseCardIfGeneralHandWasPreviouslyFullyInRange(card, presetCommunityCards, presetHoleCards, shortDeck) {
    this.forEach(function (player) {
      player.selectAllSpecificHandsThatUseCardIfGeneralHandWasPreviouslyFullyInRange(card, presetCommunityCards, presetHoleCards, shortDeck);
    });
  };
  setWhetherSpecificHandsThatUseCardArePossibleOnInitialState(card, presetCommunityCards, presetHoleCards, shortDeck) {
    this.forEach(function (player) {
      player.setWhetherSpecificHandsThatUseCardArePossibleOnInitialState(card, presetCommunityCards, presetHoleCards, shortDeck);
    });
  };
  hasEmptyRange(street) {
    let hasEmptyRange = false;

    this.forEach(function (player) {
      if (player.hasEmptyRange(street)) {
        hasEmptyRange = true;
      }
    });

    return hasEmptyRange;
  };

  // results
  setFiveCardHandValuesToDefaults(presetCommunityCards, opponentTightness, settings) {
    this.forEach(function (player) {
      player.setFiveCardHandValuesToDefaults(presetCommunityCards, opponentTightness, settings);
    });
  };

  // simulation
  setLastSimulationInfo(presetCommunityCards, presetHoleCards, playerStateIndex) {
    this.forEach(function (player) {
      player.setLastSimulationInfo(presetCommunityCards, presetHoleCards, playerStateIndex);
    });
  };

  // short deck
  adjustForShortDeck() {
    this.forEach(function (player) {
      player.adjustForShortDeck();
    });
  };
};



// WEBPACK FOOTER //
// ./src/services/player/Players.js